import { Contract, Commodity } from "@/types/contract";
import { EanPrefix, EicPrefix } from "@/constants/common";

export const getPreviousConnectionFromString = (connection: string | null) => {
  if (connection === "true") {
    return true;
  }

  if (connection === "false") {
    return false;
  }

  return null;
};

export const getPreviousConnectionString = (connection: boolean | null) => {
  if (connection === true) {
    return "true";
  }

  if (connection === false) {
    return "false";
  }

  return null;
};

export const isLDSEanOrEic = (contract: Contract, code: string | null) => {
  if (!code) {
    return false;
  }

  const eanRegex = new RegExp(/^859182400[12345678]\d+$/);
  const eanWithPrefix = code.includes(`${EanPrefix}`) ? code : `${EanPrefix}${code}`;
  const isLDSEan = !eanRegex.test(eanWithPrefix);

  const eicRegex = new RegExp(/^27ZG(100|200|300|400|500|600|700|900).*$/);
  const eicWithPrefix = code.includes(`${EicPrefix}`) ? code : `${EicPrefix}${code}`;
  const isLDSEic = !eicRegex.test(eicWithPrefix);

  return contract.supplyPoint.commodity === Commodity.Electricity ? isLDSEan : isLDSEic;
};
